import { apiClient } from './apiClient';

export interface RestaurantOnboardingData {
  first_name: string;
  last_name: string;
  restaurant_name: string;
  cuisine_type: string;
  address: string;
  city: string;
  state: string;
  zip_code: string;
  phone_number: string;
  email_opt_in: boolean;
  terms_accepted: boolean;
  privacy_accepted: boolean;
  subscription_plan?: string;
  google_rating?: number;
  rating_source?: string;
}

export interface RestaurantProfile {
  restaurant_id: string;
  restaurant_name: string;
  cuisine_type: string;
  address: string;
  city: string;
  state: string;
  zip_code: string;
  phone_number: string;
  email_opt_in: boolean;
  onboarding_completed_at: string;
  created_at: string;
}

export const restaurantApi = {
  // Complete restaurant onboarding
  async onboard(data: RestaurantOnboardingData, addLocation: boolean = false) {
    const url = addLocation ? '/restaurants/onboard?add_location=true' : '/restaurants/onboard';
    const response = await apiClient.post(url, data);
    return response.data;
  },

  // Get restaurant profile
  async getProfile(restId?: number) {
    // Use the same endpoint for both demo and regular users
    // The auth middleware handles demo session authentication
    // For demo users, optionally pass rest_id to get specific location data
    const url = restId ? `/restaurants/profile?rest_id=${restId}` : '/restaurants/profile';
    const response = await apiClient.get(url);
    return response.data;
  },

  // Update restaurant profile
  async updateProfile(data: Partial<RestaurantProfile>) {
    const response = await apiClient.put('/restaurants/profile', data);
    return response.data;
  }
};